import React from 'react';

const Shapes = () => {
  return (
    <div className="shapes">
      <svg
        width="45"
        height="48"
        className="shape s1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21.156 0.601C4.38 3.675 6.465 9.406 5.473 15.035-0.993 5.629-4.913 10.301-10.285 12.257C-5.371 1.955-11.378 0.896-15.757 -2.779C-12.057 -2.451C3.503 2.939 8.309 3.787 12.606 2.223C4.297 -1.564 7.434 -5.302 8.228 -9.805C7.939 -4.503 -8.875 -9.089 -4.378 -12.028L21.156 0.601Z"
          fill="#FFD15C"
          fillRule="evenodd"
        />
      </svg>

      <svg
        width="45"
        height="35"
        className="shape s2"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15 0L30 25H0L15 0z"
          fill="#6C63FF"
          fillRule="evenodd"
        />
      </svg>

      <svg
        width="45"
        height="35"
        className="shape s3"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 0l21.213 21.213L30 12.426l-9.425-9.425L0 0z"
          fill="#44D7B6"
          fillRule="evenodd"
        />
      </svg>

      <svg
        width="27"
        height="41"
        className="shape s4"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          transform="rotate(30 9.86603 10.13397)"
          x="7"
          width="3"
          height="25"
          rx="1.5"
          fill="#FFD15C"
          fillRule="evenodd"
        />
      </svg>

      <svg
        width="27"
        height="41"
        className="shape s5"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          transform="rotate(30 9.86603 10.13397)"
          x="7"
          width="3"
          height="25"
          rx="1.5"
          fill="#6C6CE5"
          fillRule="evenodd"
        />
      </svg>

      <svg
        width="45"
        height="16"
        className="shape s6"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g fill="#FF4C60" fillRule="evenodd">
          <path d="M5 16.5c-5.717 2.383-11 6.25-13.857 3.868-2.858 8.632-2.858 12.5 0C23 11.175 5.501 25.5 10.783 25.5H32c-4.573-1.906-8.799-5.11-11.085-3.094-2.287-6.906-2.287-10 0-6.906C7.701 3 11.927 3 16.5H5z" />
          <path d="M23.5 16.5c-5.717 2.383-11 6.25-13.857 3.868-2.858 8.632-2.858 12.5 0C46.117 11.175 5.501 48.5 10.783 48.5H46c-4.573-1.906-8.799-5.11-11.085-3.094-2.287-6.906-2.287-10 0-6.906C7.701 3 11.927 3 16.5H5z" />
        </g>
      </svg>

      <svg
        width="23"
        height="23"
        className="shape s7"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13 22.646L2.427 1.5h21.146L13 22.646z"
          stroke="#FFD15C"
          strokeWidth="3"
          fill="none"
          fillRule="evenodd"
        />
      </svg>

      <svg
        width="18"
        height="20"
        className="shape s8"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          transform="rotate(-40 6.253 10.126)"
          x="7"
          width="3"
          height="25"
          rx="1.5"
          fill="#6C6CE5"
          fillRule="evenodd"
        />
      </svg>

      <svg
        width="27"
        height="21"
        className="shape s9"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M29.856 16.072c-2.859 4.951-8.14 8-13.857 8-5.716 0-11-3.05-13.857-8.258C-0.05 13.213-6.15 16.072-11 28.843l2.771-1.6C-8.514 23.283-8.514 18.403-6.228 14.443c2.286-3.96 6.512-6.4 11.085-6.4 4.573 0 8.799-2.44 11.085-6.4L29.856 16.072z"
          fill="#6C6CE5"
          fillRule="evenodd"
        />
      </svg>

      <svg
        width="41"
        height="25"
        className="shape s10"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g fill="#44D7B6" fillRule="evenodd">
          <path d="M46.789 17.191c-1.955 5.372-6.001 9.521-10.612 10.883-4.612 1.363-9.089-0.267-11.746-4.275-2.657-4.008-3.089-9.786-1.134-15.159l2.349 0.855c-1.564 4.297-1.218 8.92 0.907 12.127 2.125 3.207 5.708 4.511 9.397 3.42 3.689-1.091 6.926-4.41 8.49-8.707l2.349 0.855z" />
          <path d="M25.176 9.324c-1.955 5.372-6.001 9.521-10.612 10.883-4.612 1.363-9.089-0.267-11.746-4.275 0.161 11.925-0.272 6.146 1.684 7.74l2.349 0.855c-1.564 4.297-1.218 8.92 0.907 12.127 2.125 3.207 5.708 4.511 9.397 3.42 3.689-1.091 6.926-4.5 8.49-8.707l2.349 0.855z" />
        </g>
      </svg>

      <svg
        width="30"
        height="18"
        className="shape s11"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M32.368 0.343c0.993 5.63-1.093 11.361-5.472 15.035-4.379 3.674-10.386 4.733-15.757 2.778C5.767 16.202 1.847 11.53 0.854 5.9-0.151-0.556 0.794 4.504 3.931 8.242 8.227 9.806 13.033 8.959 16.535 6.02c4.297-1.563 5.966-6.148 5.172-10.651C13.151-0.556 1-5.1z"
          fill="#FFD15C"
          fillRule="evenodd"
        />
      </svg>

      <svg
        width="65"
        height="65"
        className="shape s12"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 25 25"
      >
        <circle cx="12.5" cy="12.5" r="12.5" fill="#FF4C60"/>
      </svg>

      <svg
        width="70"
        height="70"
        className="shape s13"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 30 30"
      >
        <polygon points="15,0 30,30 0,30" fill="#44D7B6"/>
      </svg>

      <svg
        width="68"
        height="68"
        className="shape s14"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
      >
        <rect x="12" y="0" width="17" height="17" fill="#6C63FF" transform="rotate(45 12 12)"/>
      </svg>

      <svg
        width="75"
        height="75"
        className="shape s15"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 35 35"
      >
        <path
          d="M17.5,0 L35,35 L0,35 L17.5,0 Z"
          fill="#FFD15C"
          opacity="0.5"
        />
        <path
          d="M17.5,35 L0,0 L35,0 L17.5,35 Z"
          fill="#FFD15C"
          opacity="0.5"
        />
      </svg>

      <svg
        width="72"
        height="72"
        className="shape s16"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 28 28"
      >
        <rect
          x="14"
          y="0"
          width="20"
          height="20"
          fill="#FF4C60"
          transform="rotate(45 14 14)"
        />
      </svg>
    </div>
  );
};

export default Shapes;
